import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

function PricePositionRenderer(props) {
  const { value } = props;
  let cls = 'label-warning';
  if (value === 'Lower') {
    cls = 'label-success';
  } else if (value === 'Higher') {
    cls = 'label-danger';
  } else if (value === 'NA') {
    cls = 'label-default';
  }
  return (
    <span className={`label ${cls} ${styles.label}`}>
      {value}
    </span>
  );
}

PricePositionRenderer.propTypes = {
  value: PropTypes.string,
};
PricePositionRenderer.defaultProps = {
  value: null,
};

export default PricePositionRenderer;
